import React from "react";

export default () => <div>
    <div style={{textAlign: 'center'}}>
        <h1>404</h1>
        <h3>The page requested does not exist</h3>
    </div>
</div>
